/* generated by Svelte v4.2.19 */
import {
	add_attribute,
	create_ssr_component,
	each,
	escape,
	validate_component
} from "svelte/internal";

import ClientAppSkeleton from "@budibase/frontend-core/src/components/ClientAppSkeleton.svelte";

const Component = create_ssr_component(($$result, $$props, $$bindings, slots) => {
	let { props } = $$props;
	if ($$props.props === void 0 && $$bindings.props && props !== void 0) $$bindings.props(props);

	return `${($$result.head += `<meta charset="utf8"><meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover"><meta name="title"${add_attribute("content", props.metaTitle, 0)}><meta name="description"${add_attribute("content", props.metaDescription, 0)}><meta property="og:site_name" content="Budibase"><meta property="og:title"${add_attribute("content", props.metaTitle, 0)}><meta property="og:description"${add_attribute("content", props.metaDescription, 0)}><meta property="og:type" content="website"><meta property="og:image"${add_attribute("content", props.metaImage, 0)}><meta property="twitter:card" content="summary_large_image"><meta property="twitter:site" content="@budibase"><meta property="twitter:image"${add_attribute("content", props.metaImage, 0)}><meta property="twitter:image:alt"${add_attribute("content", props.metaTitle, 0)}><meta property="twitter:title"${add_attribute("content", props.metaTitle, 0)}><meta property="twitter:description"${add_attribute("content", props.metaDescription, 0)}>${($$result.title = `<title>${escape(props.title)}</title>`, "")}${props.favicon !== ""
	? `<link rel="icon" type="image/png"${add_attribute("href", props.favicon, 0)}>`
	: `<link rel="icon" type="image/png" href="/builder/bblogo.png">`}<link href="/builder/fonts/source-sans-3/source-sans-3.css" rel="stylesheet"><link href="/builder/fonts/inter/inter.css" rel="stylesheet"><link href="/builder/fonts/phosphor-icons/phosphor-icons.css" rel="stylesheet"><link href="/builder/fonts/remixicon.css" rel="stylesheet"><style>html,
    body {
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
    }
    *,
    *:before,
    *:after {
      box-sizing: border-box;
    }

    #error {
      position: absolute;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100vw;
      display: none;
      font-family: "Source Sans 3", sans-serif;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #222;
      text-align: center;
      padding: 2rem;
      gap: 2rem;
    }
    #error h1,
    #error h2 {
      margin: 0;
    }
    #error h1 {
      color: #ccc;
      font-size: 3rem;
      font-weight: 600;
    }
    #error h2 {
      color: #888;
      font-weight: 400;
    }

    /* Inject latest font CSS from bbui.css, as the real file is versioned with the client lib */
    .spectrum {
      --font-sans:
        "Source Sans 3", -apple-system, BlinkMacSystemFont, Segoe UI, "Inter",
        "Helvetica Neue", Arial, "Noto Sans", sans-serif !important;
      --font-accent:
        "Source Sans 3", -apple-system, BlinkMacSystemFont, Segoe UI, "Inter",
        "Helvetica Neue", Arial, "Noto Sans", sans-serif !important;
      --spectrum-alias-body-text-font-family: var(--font-sans) !important;
      --spectrum-global-font-family-base: var(--font-sans) !important;
      --spectrum-global-font-line-height-small: 1.4 !important;
    }
  </style>${props.headAppScripts || ""}`, "")} <body id="app">${props.showSkeletonLoader
	? `${validate_component(ClientAppSkeleton, "ClientAppSkeleton").$$render(
			$$result,
			{
				hideDevTools: props.hideDevTools,
				sideNav: props.sideNav,
				hideFooter: props.hideFooter
			},
			{},
			{}
		)}`
	: ``} <div id="error">${props.clientLibPath
	? `<h1>There was an error loading your app</h1> <h2>The Budibase client library could not be loaded. Try republishing your
        app.</h2>`
	: `<h2>We couldn&#39;t find that application</h2> <p></p>`}</div> ${props.recaptchaKey
	? `<script src="https://www.google.com/recaptcha/api.js"></script>`
	: ``} <script type="application/javascript"${add_attribute("nonce", props.nonce, 0)}>window.INIT_TIME = Date.now()</script> ${props.appMigrating
	? `<script type="application/javascript"${add_attribute("nonce", props.nonce, 0)}>window.MIGRATING_APP = true</script>`
	: ``} <script type="application/javascript"${add_attribute("src", props.clientLibPath, 0)}></script>   ${(props.usedPlugins?.length)
	? `${each(props.usedPlugins, plugin => {
			return `<script type="application/javascript"${add_attribute("src", plugin.jsUrl, 0)}></script>`;
		})}`
	: ``} <script type="application/javascript"${add_attribute("nonce", props.nonce, 0)}>if (window.loadBudibase) {
      window.loadBudibase()
    } else {
      console.error("Failed to load the Budibase client")
      document.getElementById("error").style.display = "flex"
    }</script>  ${props.bodyAppScripts || ""}</body>`;
});

export default Component;